const metaWindows = { 
  layout: 'windows', 
  layoutClass: 'dashboard', 
  logo: 'images/logos/LOGO Netplus - COLOR.png', 
  bg_login: 'images/login/login_bg.png', 
  paramsPayment: null,
  typeAuth: null,
  username: null,
  signup_token: null,
}

const metaDashBoard = { 
  layoutClass: 'dashboard', 
  authCRM: '', 
  token_portal: '', 
  myCliente: '', 
  mySystem: '',
  typeRoute: '',
  toggleLoading: false, 
  paramsPayment: null, 
  invoices: '', 
  typeUser: '',
  typeRoute: '',
  simulate: false,
  bcv_usd: 0,
  prevMenu: []
}

const Aditional = { 
  myCliente: '', 
  mySystem: '',
  layoutclass: 'dashboard', 
  paramsPayment: null, 
  toggleLoading: true,
  typeUser: '',
  typeRoute: '',
  aditional: true,
  bcv_usd: 0,
  prevMenu: []
}

const Hostspot = { 
  layout: 'hostspot',
  layoutclass: 'dashboard', 
  folderData: 'default'
}

const addLayoutToRoute = (route, parentLayout = 'default') => {
    route.meta = route.meta || {};
    route.meta.layout = route.meta.layout || parentLayout;
    if (route.children) {
      route.children = route.children.map((childRoute) => {
        childRoute = addLayoutToRoute(childRoute, route.meta.layout);
        return childRoute;
      });
    }
    return route;
}

export { metaWindows, metaDashBoard, Aditional, Hostspot, addLayoutToRoute }